/* eslint-disable react/prop-types */
import BigNumber from 'bignumber.js';
import { CONSULT_ACCEPTED } from 'Constants/consults';
import { CurrencyLabel } from 'Modules/Currency';
import { useSelector } from 'react-redux';
import { Placeholder } from 'semantic-ui-react';

import styles from './FeeContent.less';

const formatTimeCall = totalMinute => {
  const minute = Math.ceil(totalMinute);
  const textMin = minute > 1 ? 'mins' : 'min';
  return `${minute} ${textMin}`;
};

const FeeAccumulative = ({ consultFee, isViewMode }) => {
  const isOngoingConsult = consultFee?.consult?.status === CONSULT_ACCEPTED;
  const {
    estimate,
    status: { estimate: estimateStatus },
  } = useSelector(state => state.webChat.consultFee);

  const fee = isOngoingConsult ? estimate || { feeSetting: {} } : consultFee;
  const {
    initialFee,
    feeSetting: { subsequentMessageFee, subsequentMinuteFee },
    subsequentMinuteFee: totalMinutesFee,
    subsequentFee: totalMessageFee,
    priorityQueueFee,
    surchargeFee,
    practiceCost,
    adminFee,
    appliedAdminFee,
  } = fee;

  const renderWithSkeleton = child =>
    estimateStatus === 0 ? (
      <div style={{ width: '60px' }}>
        <Placeholder>
          <Placeholder.Line />
        </Placeholder>
      </div>
    ) : (
      child
    );
  const { subMessagesCount, subMinutesCount } = isOngoingConsult
    ? fee
    : consultFee.consult || { subMessagesCount: 0, subMinutesCount: 0 };

  // eslint-disable-next-line max-len
  const textSubsequent = `Subsequent messages (${
    subMessagesCount || 0
  } messages x ${subsequentMessageFee})`;
  const textVideo = `Subsequent call minutes (${formatTimeCall(
    subMinutesCount || 0,
  )} x ${subsequentMinuteFee})`;
  const videoFee = +new BigNumber(totalMinutesFee).decimalPlaces(2, 1);

  return (
    <div>
      {!isViewMode && (
        <div className={styles.item}>
          <strong>Fee Breakdown</strong>
        </div>
      )}
      <div className={styles.feeChatContainer}>
        {appliedAdminFee ? (
          <div className={styles.item}>
            <div className={styles.label}>Admin fee</div>
            <div className={styles.value}>
              {renderWithSkeleton(<CurrencyLabel value={adminFee} />)}
            </div>
          </div>
        ) : (
          <>
            <div className={styles.item}>
              <div className={styles.label}>Initial fee</div>
              <div className={styles.value}>
                {renderWithSkeleton(<CurrencyLabel value={initialFee} />)}
              </div>
            </div>
            {!!surchargeFee && (
              <div className={styles.item}>
                <div className={styles.label}>Surcharge</div>
                <div className={styles.value}>
                  {renderWithSkeleton(<CurrencyLabel value={surchargeFee} />)}
                </div>
              </div>
            )}
            <div className={styles.item}>
              <div className={styles.label} style={{ paddingRight: 8 }}>
                {textSubsequent}
              </div>
              <div className={styles.value}>
                {renderWithSkeleton(<CurrencyLabel value={totalMessageFee} />)}
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.label} style={{ paddingRight: 8 }}>
                {textVideo}
              </div>
              <div className={styles.value}>
                {renderWithSkeleton(<CurrencyLabel value={videoFee} />)}
              </div>
            </div>
            {!!priorityQueueFee && (
              <div className={styles.item}>
                <div className={styles.label}>Priority queue</div>
                <div className={styles.value}>
                  {renderWithSkeleton(<CurrencyLabel value={priorityQueueFee} />)}
                </div>
              </div>
            )}
            {practiceCost > 0 && (
              <div className={styles.item}>
                <div className={styles.label}>Practice cost</div>
                <div className={styles.value}>
                  {renderWithSkeleton(<CurrencyLabel value={practiceCost} />)}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default FeeAccumulative;
